import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import moment from 'moment';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import { getPositionOfEventScroll } from '@/util/common-util';

const briefingStore = namespace('briefingStore');

export const innitNtfSummaryDetails: ntfSummaryDetail = {
  summaryContent: '',
  publishedDate: '',
  publisher: '',
  title: '',
  registDate: '',
  url: '',
  docId: '',
};

export interface ntfSummaryDetail {
  publisher: string;
  title: string;
  summaryContent: string;
  registDate: string;
  url: string;
  publishedDate: string;
  docId: string;
}

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class PublicNotificationSummaryWidgetComponent extends Vue {
  @Prop(Object) readonly publicNotificationSummaryWidgetData: any | null;
  @Prop(String) readonly companyBpName: string | '';
  @Prop(Object) readonly bpUserProfile: any | undefined;

  @briefingStore.Mutation
  public setCompanyWidgetDetail: (payload: any) => void;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;

  notificationSummaryDataList = [];
  notificationSummaryDataDetail = [];
  ntfSummaryDetail: any = innitNtfSummaryDetails;

  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        slidesPerColumn: 1,
        spaceBetween: 14,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 1,
          },
          500: {
            slidesPerView: 2,
            slidesPerColumn: 1,
            spaceBetween: 2,
          },
          768: {
            slidesPerView: 3,
            slidesPerColumn: 1,
            spaceBetween: 14,
          },
        },
      },
    };
  }

  mounted() {
    this.notificationSummaryDataList = [];
    this.setData();
  }

  @Watch('publicNotificationSummaryWidgetData')
  onPublicNotificationSummaryWidgetDataChange() {
    this.notificationSummaryDataList = [];
    this.setData();
  }

  @Watch('$route.name')
  onNameChange() {
    this.notificationSummaryDataList = [];
    this.setData();
  }

  setData() {
    if (
      this.publicNotificationSummaryWidgetData &&
      this.publicNotificationSummaryWidgetData?.listParentDocInfos &&
      this.publicNotificationSummaryWidgetData?.listParentDocInfos?.length > 0
    ) {
      const tempData = this.publicNotificationSummaryWidgetData.listParentDocInfos || [];
      const tempList = [];

      if (tempData && tempData.length > 0) {
        tempData.forEach(item => {
          let tempContent = item.title || '';
          tempContent = tempContent.trim();

          if (tempContent && tempContent !== undefined && tempContent !== '' && tempContent !== 'null' && tempContent !== null) {
            tempList.push(item);
          }
        });

        this.notificationSummaryDataList = tempList;
      } else {
        this.notificationSummaryDataList = [];
      }
    } else {
      this.notificationSummaryDataList = [];
    }
  }

  async getDataDetail(index) {
    // this.loading = false;
    if (
      this.publicNotificationSummaryWidgetData &&
      this.publicNotificationSummaryWidgetData?.listParentDocInfos &&
      this.publicNotificationSummaryWidgetData?.listParentDocInfos?.length > 0
    ) {
      await this.discoveryService()
        .getDetailService(this.publicNotificationSummaryWidgetData.listParentDocInfos[index].parent_doc_id)
        .then(res => {
          if (res?.data) {
            this.notificationSummaryDataDetail = res.data;
            this.ntfSummaryDetail = JSON.parse(res?.data?.serviceHtml);
            // this.loading = true;
          } else {
            this.ntfSummaryDetail = innitNtfSummaryDetails;
            // this.loading = true;
          }
        });
    }
  }

  makeDate(inputData: string) {
    if (inputData && inputData.trim().length > 0) {
      let tempData = inputData.trim().replace('T00:00', '');

      if (tempData.includes('T') || tempData.includes('Z')) {
        tempData = tempData.slice(0, 10);
      }

      return tempData;
    } else {
      return '';
    }
  }

  async handleOpenDetail(indexInput: number, event) {
    if (indexInput > -1) {
      const lastPosition = this.finePosition(event);
      this.$emit('updateLastPosition', lastPosition);
      await this.getDataDetail(indexInput);
      this.setCompanyWidgetDetail({
        name: 'PublicNotificationSummaryDetail',
        widgetData: {
          companyBpName: this.companyBpName || '',
          userProfile: this.bpUserProfile || null,
          ntfSummaryDetail: this.ntfSummaryDetail || null,
          notificationSummaryDataDetail: this.notificationSummaryDataDetail || null,
        },
      });
    }
  }

  private finePosition(event: Event): number {
    const widget = document.getElementById('public-notify-widget') as HTMLElement;
    return getPositionOfEventScroll(event, widget);
  }
}
